import { createConsumer } from '@rails/actioncable'
import { ACTION_CABLE_URL } from '../config'

const consumer = createConsumer(ACTION_CABLE_URL + '?token=' + localStorage.access)

export default consumer
